<template>
  <v-card flat color="blue lighten-5" class="outline mt-3">
    <v-card-text>
      <v-layout row>
        <v-flex xs10 sm6 md3>
          <v-select clearable
            v-model="localStatus"
            :label="$t('checklists.overall-status')"
            :items="statusIndex"
            :disabled="locked"
          ></v-select>
        </v-flex>
        <v-flex grow class="text-right" v-if="locked">
          <v-icon :title="$t('checklists.locked')">lock</v-icon>
        </v-flex>
      </v-layout>
      <v-layout row v-if="showRemarks">
        <v-flex xs12>
          <v-textarea
            v-model="localRemarks"
            :label="$t('checklists.summary-remarks')"
            :error="remarksRequired"
            :disabled="locked"
            rows="1"
            auto-grow
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="back">{{ $t('back') }}</v-btn>
      <v-spacer/>
      <v-btn :disabled="!locked" @click="unlock">{{ $t('checklists.unlock') }}</v-btn>
      <v-btn :disabled="saved || !confirmDisabled" @click="save" :title="$t('checklists.save')">{{ $t('save') }}</v-btn>
      <v-btn :disabled="confirmDisabled" @click="confirm" :title="$t('checklists.save-and-confirm')" color="primary">{{ $t('save-and-confirm') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'checklist-summary',
  props: {
    valid: [Boolean, Object], // validation status + null
    saved: Boolean,
    status: String,
    remarks: String
  },
  data () {
    return {
      localStatus: null,
      localRemarks: null
    }
  },
  created () {
    this.localStatus = this.status
    this.localRemarks = this.remarks
  },
  computed: {
    statusIndex () {
      return [
        { value: 'OK', text: this.$t('checklists.ok'), disabled: !this.valid },
        { value: 'OK_REMARKS', text: this.$t('checklists.ok-with-remarks') },
        { value: 'NOT_OK', text: this.$t('checklists.not-ok') }
      ]
    },
    showRemarks () {
      return this.localStatus && this.localStatus !== 'OK'
    },
    remarksRequired () {
      return this.localStatus === 'OK_REMARKS' && !this.localRemarks
    },
    confirmDisabled () {
      return this.locked || !this.localStatus || (this.localStatus === 'OK_REMARKS' && !this.localRemarks)
    },
    locked () {
      return this.$store.getters['checklist/isLocked']
    }
  },
  methods: {
    back () {
      this.$emit('back')
    },
    save () {
      this.$emit('save')
    },
    confirm () {
      const status = this.localStatus
      const remarks = status === 'OK' ? null : (this.localRemarks || null)

      this.$emit('update', {
        status,
        remarks
      })
    },
    unlock () {
      this.localStatus = null
      this.localRemarks = null

      this.$emit('update', {
        status: null,
        remarks: null
      })
    }
  },
  watch: {
    valid (valid) {
      if (!valid && this.localStatus === 'OK') {
        this.localStatus = null // clear status
      }
    }
  }
}
</script>
